module.exports = __webpack_public_path__ + "static/media/logo-xmas-mobile.514b719f.svg";